import { render, staticRenderFns } from "./FooterSpineSymposium.vue?vue&type=template&id=22472e39&"
import script from "./FooterSpineSymposium.vue?vue&type=script&lang=js&"
export * from "./FooterSpineSymposium.vue?vue&type=script&lang=js&"
import style0 from "./FooterSpineSymposium.vue?vue&type=style&index=0&id=22472e39&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports